module.exports = __webpack_public_path__ + "static/media/list-icon-active.578ea83e.svg";